import { render, staticRenderFns } from "./platformNotice.vue?vue&type=template&id=7cca70fd"
import script from "./platformNotice.vue?vue&type=script&lang=ts"
export * from "./platformNotice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports